<template>
<div :style="{ backgroundColor: backgroundcolor }" id="wrapper">
   <div id="logo_chat_nuevo">
     <div id="logo_chat">
          <img style="margin: 10px" src="https://imagenes.leon.gob.mx/logo-leon.svg" width="150px" >
     </div>
       <div id="logo_leon">
          <img style="margin: 10px" src="img/logoatencion.png" width="100px" >
     </div>
  </div>
  <div>
      <!-- chat de ciudadano -->
     
      <div id="chat" style="overflow-y: scroll; overflow-x:hidden;width: auto; height: 350px; margin:10px; border:1px solid #e7e5e5;">
        <div class="row" style="margin-left:10px; text-align:left; margin-top:5px" 
              v-for="message in this.chatMessages.slice().reverse()" :key="message.key">
        <div v-if="message.details.type=='op'">
          <div class="alert alert-primary" role="alert">
            <span class=""><i class="fa fa-user-tie" style="color:#2C4DB8;"></i></span>
            <strong> Operador : </strong>{{message.details.mensaje}}
          </div>
        </div>
        <div v-if="message.details.type=='us'">
          <div class="alert alert-warning" role="alert">
             <span class=""><i class="fa fa-user" style="color:#b39226 "></i></span>
            <strong> Tú : </strong> {{message.details.mensaje}}
          </div>
        </div>
        </div>
    </div>

     <div class="row row justify-content-center" >
      <div class="col-11 has-danger">
        <div class="input-group ">
           <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0"><i class="fa fa-user" style="color:#000;"></i></span>
          </div>
          <input id="inputOpMsg"  autocomplete="off" type="text" class="form-control border-left-0" placeholder="Escribe tu mensaje" v-model="mensaje" v-on:keyup.13="sendMessUser">
          <div class="input-group-append">
            <button v-on:click="sendMessUser" class="btn btn-warning" style="background-color:#006E67;border-color:#006E67;">Enviar</button>
              <button v-on:click="confirmEndChat" class="btn btn-danger" style="background-color:#f6A800;border-color:#f6A800;">Terminar</button>
          </div>
        </div><br/>
        
      </div>
       </div>
  </div>
              </div>
</template>

<script>
import firebase from 'firebase';

/* Chat de usuario*/
export default {
  name: 'Atencion',
  props: {
    msg: String
  },
 data() {
    return {
      name: null,
      mensaje: null,
      key: null,
      messages: null,
      status:null,
      claseMensaje:null,
       backgroundcolor: "#EEEEED",
    }
  },
  methods: {
    bottomChatWindow:function(){
      var container = this.$el.querySelector("#chat");
      container.scrollTop = container.scrollHeight;
    },
    startIntervalChatWindowBottom:function(){
      var self = this;
      setInterval(()=>{
        self.bottomChatWindow();
      },1000)
    },
    sendMessUser() {
      if(this.mensaje!=""){
        this.claseMensaje="primary"
        firebase.database().ref(`chats/current/${this.$route.params.keyId}`).push({
          type: "us",
          mensaje: this.mensaje,
          date: Date.now()
        })
        this.mensaje = "";
      }
      else{
        this.claseMensaje="danger"
      }
    },
     confirmEndChat(){
      var confirmEnd =  confirm("¿ Deseas terminar la conversación ?");
      if(confirmEnd){
        this.UserEndsChat();
      }
    },
    /* Cuando el operador manda mensaje o termina conversación */
    onReceiveNotifications() {
      var self = this;
      var ref = firebase.database().ref(`chats/current/${this.$route.params.keyId}`);
      ref.on('value', function (snapshot) {
        self.messages = [];
        setTimeout(self.bottomChatWindow,1000)
        snapshot.forEach(element => {
          self.messages.push({
            details: element.val()
          });
        });

      });
    },
    removeCookie(){
      localStorage.removeItem('sesionID');
    },
    onOperatorRefreshOrExitListener() {
      /* El operador cerro la ventana o refresco, se actualiza el status */
      var self = this;
      // console.log(`monito ${localStorage.sesionID}`)
      var ref = firebase.database().ref(`lobby/users/${localStorage.sesionID}`);      
      ref.on('value', function (snapshot) {
        // console.log(snapshot.val())
        if(snapshot.val()!=undefined){
         if(snapshot.val().status==2){
             self.$router.push({
             name: "Login"
          })
         }
          self.status = snapshot.val().status;
        }
      })
    },

    UserEndsChat() {
      /* Ciudadano termina la conversacion  */
      // console.log("usuario termina conversacio");
      if(this.$route.params.keyId!=undefined){
        firebase.database().ref(`lobby/users/${this.$route.params.keyId}`).update({
          'status': "2"
        });
        /* lo borra el operador */
        //firebase.database().ref(`lobby/users/${this.$route.params.keyId}`).remove()
        localStorage.removeItem('sesionID');
        this.$router.push({
          name: "Login"
         })
      }
    },


    onUserCloseBrowser() {
      if(this.$route.params.keyId!=undefined){
        firebase.database().ref(`chats/current/${this.$route.params.keyId}`).push({
          type: "us",
          mensaje: ". . . ",
          date: Date.now()
        });
        /* actualiza status*/
        // console.log("se actualiza a 4")
        firebase.database().ref(`lobby/users/${this.$route.params.keyId}`).update({
          'status': "4"
        });
      }
    },
    
   
  },
  created() {
    this.messages = [];
    
   
    if (localStorage.sesionID==null) {
      this.$router.push({
        name: "Login"
      })
    } 
    else{
      //this.startIntervalChatWindowBottom();
      window.addEventListener('beforeunload', this.onUserCloseBrowser);
      this.key = this.$route.params.keyId;
      this.ipAddress = this.$route.params.ipAddress
      //  console.log(this.ipAddress)
      firebase.database().ref(`lobby/users/${this.$route.params.keyId}`).update({
          'status': "1"
        });
      this.onReceiveNotifications();
      this.onOperatorRefreshOrExitListener();
    }

  },
  computed: {
    chatMessages: function () {
      return this.messages.reverse()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#logo_leon{
  flex-direction: column;
}
#logo_chat{
    flex-direction: column;

}
#logo_chat_nuevo{
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
   padding-left: 20px;
   padding-right: 20px;
}

#wrapper {
  margin: 0;
  padding: 0px 10px;
  background-color: blueviolet;
  width: 100%;
}
#chat{
   font-family: 'Noto Sans JP', sans-serif;
   font-size: 13px;
   background-color: white;
}
button{
  font-family: 'Noto Sans JP', sans-serif;
   font-size: 13px;
   color: white;
   
}
input{
   font-family: 'Noto Sans JP', sans-serif;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}
input {
 outline:none;
}
</style>